module.exports = __webpack_public_path__ + "img/R6__1235.0e7f92b4.jpeg";